import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// allowedRoles: number[] (e.g., [1,2,3])
export default function RoleRoute({ allowedRoles = [] }) {
  const token = localStorage.getItem('authToken');
  if (!token) return <Navigate to="/login" replace />;

  const role = Number(localStorage.getItem('userRole'));
  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

